module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<head>\n<title></title>\n<meta charset="UTF-8">\n<meta content=\'width=device-width; initial-scale=1.0;\' name=\'viewport\' />\n<meta name="x-apple-disable-message-reformatting">\n<meta http-equiv="X-UA-Compatible" content="IE=edge">\n<meta content="telephone=no" name="format-detection">\n<style type="text/css">\ntable,td{background-size: 100% 100%;}\nu~div table.gmail_w {background-image:none!important;}\ndiv.templateContainerInner > table, div.templateContainerInner .zmags_w{width:auto;}\n' +
((__t = (gmailStyles)) == null ? '' : __t) +
'\n' +
((__t = (styles)) == null ? '' : __t) +
'\n</style>\n<!--[if gte mso 9]>\n<xml>\n    <o:OfficeDocumentSettings>\n        <o:AllowPNG/>\n        <o:PixelsPerInch>96</o:PixelsPerInch>\n    </o:OfficeDocumentSettings>\n</xml>\n<![endif]-->\n</head>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/email/renderer/EmailMetaData.tpl
// module id = 2929
// module chunks = 0